import React from "react";
import { useTranslation } from "react-i18next";
import InsuranceClaimInvoice from "../Pages/insuranceClaimInvoice/InsuranceClaimInvoice";
import CustomTabs from "../components/Shared/CustomTabs";
import InsuranceClaimRevokeInvoices from "../Pages/insuranceClaimInvoice/InsuranceClaimRevokeInvoices";

function ClaimInsurancePage({ activeTab, childIndex }) {
  const { t } = useTranslation();

  const claimTabs = (t) => {
    return [
      {
        name: t("invoices"),
        content: <InsuranceClaimInvoice activeTab={activeTab} ThirdParty />,
      },
      {
        name: t("Credit Notes"),
        content: (
          <InsuranceClaimRevokeInvoices activeTab={activeTab} ThirdParty />
        ),
      },
    ];
  };

  return (
    <div>
      <CustomTabs tabs={claimTabs(t)} activeTabIndex={childIndex} />
    </div>
  );
}

export default ClaimInsurancePage;
